// extracted by mini-css-extract-plugin
export default {"container":"DraggableOverlay_container__P9IKw","top":"DraggableOverlay_top__6txWC","groupColor":"DraggableOverlay_groupColor__MOpna"};